import styled from '@emotion/styled';
import MuiGrid from '@mui/material/Grid';

export const Grid = styled(MuiGrid)`
  height: 400px;
  margin-top: ${({ theme }) => theme.spacing(4)};
`;
